import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, retry, throwError, timer } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotifierService } from '@lib/services/common/notifier-service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private notifierService = inject(NotifierService);
  private router = inject(Router);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      retry({ count: 2, delay: this.shouldRetry }),
      catchError((err: HttpErrorResponse) => {
        if (err.url?.includes('.svg')) {
          return throwError(() => err);
        }

        if (err.status === 403) {
          localStorage.clear();
          this.notifierService.error('Unauthorized', { autoClose: true });
        } else {
          this.notifierService.error(
            err && err.error && err.error.message ? err.error.message : 'Unexpected error occurred',
            {
              autoClose: true,
              keepAfterRouteChange: true,
            },
          );
        }

        if (req.url.includes('GetMyOrganizationAndUsers')) {
          void this.router.navigate(['/error'], { state: { status: err.status } });
        }

        return throwError(() => err);
      }),
    );
  }

  shouldRetry(err: HttpErrorResponse) {
    if (err.url?.includes('token') || err.url?.includes('jwks') || err.url?.includes('.svg')) {
      throw err;
    }

    if (err.status == 502) {
      return timer(1000);
    }

    throw err;
  }
}
